export * from "../../original/js/components/slider";

// soon to be depricated.
import { Slider } from "../../original/js/components/slider";

export default Slider
